import React, {useEffect, useState} from 'react';
import {DndProvider, useDrag, useDrop} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";

const DragDropItem = ({ item, index, moveItem, renderContent, onReorder, itemList }) => {

    const [, ref] = useDrag({
        type: 'ITEM',
        item: { index },
    });

    const [, drop] = useDrop({
        accept: 'ITEM',
        hover(hoverItem) {
            if (hoverItem.index === index) return;

            moveItem(hoverItem.index, index);
            hoverItem.index = index;
        },
        drop: (item) => {
            const reorderedList = [...itemList].map((item, index) => ({ ...item, showOrder: index + 1 }));
            onReorder( {from : item.index, to : index, item: item, list : reorderedList } );
        },
    });

    return (
        <div ref={(node) => ref(drop(node))} className={'draggable-item'}>
            {renderContent(item, index)}
        </div>
    );
};

export const DragDropList = ({ items, renderContent, onReorder, orientationHV= 'vertical-container', className, loading= false, renderEnd = null, groupIndex = null }) => {
    const [itemList, setItemList] = useState(items || []);

    useEffect(() => {
        if (items?.length)
            setItemList(items);
    }, [items]);

    const moveItem = (fromIndex, toIndex) => {
        const updatedItems = [...itemList];
        const [movedItem] = updatedItems.splice(fromIndex, 1);
        updatedItems.splice(toIndex, 0, movedItem);

        const reorderedList = updatedItems.map((item, index) => ({...item, showOrder: index + 1}))
        setItemList(reorderedList);
    };

    if (loading)
        return <center>
            <i className="fa fa-spinner fa-spin fa-3x fa-fw"/>
            <br/><br/>
            Cargando...
        </center>

    if (itemList.length === 0)
        return <center>
            <i className="fa fa-ban fa-fw fa-3x fa-fw"/>
            <br/><br/>
            No hay elementos para mostrar
        </center>

    return <DndProvider backend={HTML5Backend}>
        <div className={'' + orientationHV + ' ' + className}>
            {itemList.map((item, index) => (
                <DragDropItem
                    key={index}
                    index={index}
                    item={item}
                    moveItem={moveItem}
                    renderContent={renderContent}
                    itemList={itemList}
                    onReorder={onReorder}
                />
            ))}
        {
                    renderEnd !== null && renderEnd(groupIndex)
                }</div>
    </DndProvider>
};